import { createBrowserHistory } from 'history';
import ReactGA from 'react-ga';
import { UserService } from '@pingum/api-services';
import * as types from './types';
import {
  dispatchNetworkRequest,
  dispatchNetworkRequestDynamicSuccessDispatch,
} from '../networkDispatcher';
import { getTenantFromUrl } from '../../utils/urlHelper';
import { redirectToSubdomain } from '../../utils/tenantAuthenticationHelper';

export const handleLoginRequest = ({
  promise,
  history,
}) => {
  promise.then((user) => {
    if (!UserService.userHasTenants(user)) {
      history.push({ pathname: '/welcome' });
      history.go();
    } else if (!getTenantFromUrl()) {
      const tenant = global.window.localStorage.getItem('redirectTenant');
      const redirect = global.window.localStorage.getItem('redirect') || '/dashboards';
      window.localStorage.removeItem('redirectTenant');
      if (tenant) {
        redirectToSubdomain({
          tenant,
          redirect,
        });
      } else {
        history.push({ pathname: '/organizations' });
        history.go();
      }
    }
  }).catch((error) => {
    ReactGA.event({
      category: 'Error',
      action: 'Handle Login Request',
      label: error.message,
    });
  });
};

export const getMyTenants = () => (dispatch) => {
  dispatchNetworkRequest({
    dispatch,
    requestType: types.USER_TENANTS_REQUESTED,
    successType: types.USER_TENANTS_SUCCESS,
    errorType: types.USER_TENANTS_ERROR,
    promise: UserService.getMyTenants(),
    defaultErrorMessage: 'There was a problem loading your organizations',
    responseName: 'tenants',
  });
};

export const searchUsers = (search) => (dispatch) => {
  dispatchNetworkRequest({
    dispatch,
    requestType: types.SEARCH_USERS_REQUESTED,
    successType: types.SEARCH_USERS_SUCCESS,
    errorType: types.SEARCH_USERS_ERROR,
    promise: UserService.searchUsers(search),
    defaultErrorMessage: 'There was an error searching for users',
    responseName: 'searchUsers',
  });
};

export const leaveTenant = (tenantName) => (dispatch) => {
  dispatchNetworkRequestDynamicSuccessDispatch({
    dispatch,
    requestType: types.USER_LEAVE_TENANT_REQUESTED,
    successDispatch: {
      type: types.USER_LEAVE_TENANT_SUCCESS,
      leaveTenantName: tenantName,
    },
    errorType: types.USER_LEAVE_TENANT_ERROR,
    promise: UserService.leaveTenant(tenantName),
    defaultErrorMessage: 'There was a problem leaving this organization',
    successMessage: 'Successfully left the organization',
    responseName: 'leaveTenantResponse',
  });
};

export const getMe = ({
  isLoginRequest = false,
  history = createBrowserHistory(),
} = {}) => (dispatch) => {
  const promise = UserService.getMe();
  if (isLoginRequest) {
    handleLoginRequest({
      promise,
      history,
    });
  }
  dispatchNetworkRequest({
    dispatch,
    requestType: types.ME_REQUESTED,
    successType: types.ME_SUCCESS,
    errorType: types.ME_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem loading your user information',
    responseName: 'user',
  });
};

export const updateUser = (auth0UserId, updateUserRequest) => (dispatch) => {
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_USER_REQUESTED,
    successType: types.UPDATE_USER_SUCCESS,
    errorType: types.UPDATE_USER_ERROR,
    promise: UserService.updateUser(auth0UserId, updateUserRequest),
    defaultErrorMessage: 'There was a problem updating your user information',
    successMessage: 'Successfully updated your profile',
    responseName: 'user',
  });
};

export const getMySeenTutorials = () => (dispatch) => {
  dispatchNetworkRequest({
    dispatch,
    requestType: types.USER_TUTORIALS_REQUESTED,
    successType: types.USER_TUTORIALS_SUCCESS,
    errorType: types.USER_TUTORIALS_ERROR,
    promise: UserService.getMySeenTutorials(),
    defaultErrorMessage: 'There was a problem loading your tutorials',
    responseName: 'seenTutorials',
  });
};

export const updateMySeenTutorials = (request) => (dispatch) => {
  const promise = UserService.updateMySeenTutorials(request);
  dispatchNetworkRequest({
    dispatch,
    requestType: types.UPDATE_USER_TUTORIALS_REQUESTED,
    successType: types.UPDATE_USER_TUTORIALS_SUCCESS,
    errorType: types.UPDATE_USER_TUTORIALS_ERROR,
    promise,
    defaultErrorMessage: 'There was a problem updating your seen tutorials',
    responseName: 'updatedSeenTutorials',
  });
  return promise;
};
